import { MoreVertIcon } from "../../images/MoreVertIcon";
import { CircularProgress, IconButton } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import React, { useState } from "react";
import { StyledMenu } from "../StyledMenu";
import { CrmTypes } from "../../../types";
import { useDisconnectCRMMutation } from "../../../api";
import { IconWrapper } from "../IconWrapper";
import { toast } from "react-toastify";
import { CustomToast } from "../CustomToast";
import { getErrorMessage } from "../../../utils/getErrorMessage";

type Props = {
  crm: CrmTypes;
  onDisconnect: () => void;
};

export const DisconnectCRMBtn = ({ crm, onDisconnect }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [disconnectCRM, { isLoading }] = useDisconnectCRMMutation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const disconnectHandler = () => {
    disconnectCRM(crm)
      .unwrap()
      .then(() => {
        handleClose();
        onDisconnect();
      })
      .catch((err) =>
        toast.error(
          <CustomToast
            type="error"
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
            title="Failed to Disconnect"
          />,
        ),
      );
  };

  if (isLoading)
    return (
      <IconWrapper width={"40px"} height={"40px"}>
        <CircularProgress size={20} sx={{ color: "#1C3C6C" }} />
      </IconWrapper>
    );

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon width="24" />
      </IconButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "white",
          },
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          style: {
            transform: "translateX(12px)",
          },
        }}
      >
        <MenuItem
          // disabled={disabled}
          sx={{ display: "flex", gap: "12px", alignItems: "center" }}
          onClick={disconnectHandler}
        >
          Disconnect
        </MenuItem>
      </StyledMenu>
    </>
  );
};
